// eslint-disable-next-line import/prefer-default-export
export const RATE_TABLE_FOOTER_DISCLOSURE = 'rateTableFooterDisclosure'
